import { IRootState } from '../../../store'
import { IHomeFilterState } from '../store/home.types'

export const getFilterSelector = (state: IRootState): IHomeFilterState => state.home.filter
